/* Formato selector on product cards and box modal rows.
 *
 * Two parts:
 * 1. A delegated 'change' handler: the add-to-cart handlers read the
 *    button's data-variant-id at click time, so switching format only
 *    updates that attribute plus the visible price and unit price.
 * 2. A standalone copy of the theme's brand listbox (same .mp-select
 *    classes as the marketplace filters, compact modifier) so the open
 *    dropdown is branded too — the native <select> popup is OS-drawn
 *    and cannot be styled. The native select stays hidden in the DOM as
 *    the source of truth and fires 'change' like before.
 *
 * window.mpEnhanceVariantSelects(root) enhances any not-yet-enhanced
 * .mp-prod-card__variant / .mp-modal__variant inside root; the box
 * modal calls it after building its rows.
 */
(function () {
  /* ── 1. Variant switch → card state ────────────────────────────── */

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.mp-prod-card__variant');
    if (!sel) return;
    // le due card hanno classi diverse ma lo stesso meccanismo:
    // meglio un selettore in piu' qui che una seconda copia del file
    var card = sel.closest('.mp-prod-card, .pr-prod-card');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    var btn = card.querySelector('.mp-prod-card__add, .pr-prod-card__add');
    if (btn && !btn.disabled) btn.dataset.variantId = sel.value;

    var price = card.querySelector('.mp-prod-card__price, .pr-prod-card__price');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;

    var unit = card.querySelector('.mp-prod-card__unit, .pr-prod-card__unit');
    if (unit) unit.textContent = opt.dataset.unit || '';

    // la nota del risparmio sparisce quando il formato conveniente e' gia'
    // quello scelto: altrimenti consiglia una cosa gia' fatta
    var nota = card.querySelector('.mp-prod-card__risparmio, .pr-prod-card__risparmio');
    if (nota) nota.hidden = opt.dataset.migliore === 'si';
  });

  /* ── 2. Brand listbox (compact variant of the filters widget) ───── */

  var openWidget = null;
  var uid = 0;

  document.addEventListener('click', function (e) {
    if (openWidget && !openWidget.root.contains(e.target)) openWidget.close();
  });
  document.addEventListener('mp:close-selects', function () {
    if (openWidget) openWidget.close();
  });

  function enhance(sel) {
    if (sel.closest('.mp-select')) return; // già fatto

    var id = 'mp-variant-select-' + (++uid);
    var root = document.createElement('div');
    root.className = 'mp-select mp-select--compact';
    sel.parentNode.insertBefore(root, sel);
    root.appendChild(sel);
    sel.classList.add('mp-select__native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    // La card che ospita il selettore. Serve per alzarla mentre il pannello e'
    // aperto: vedi .mp-card-sopra in marketplace-page.css.
    var cardOspite = root.closest('.mp-prod-card, .pr-prod-card');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mp-select__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="mp-select__value" id="' + id + '-value"></span>' +
      '<svg class="mp-select__chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (sel.getAttribute('aria-label')) {
      btn.setAttribute('aria-label', sel.getAttribute('aria-label'));
    }

    var list = document.createElement('ul');
    list.className = 'mp-select__list';
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    btn.setAttribute('aria-controls', list.id);

    var options = Array.from(sel.options).map(function (opt, i) {
      var li = document.createElement('li');
      li.className = 'mp-select__option';
      li.id = id + '-opt-' + i;
      li.setAttribute('role', 'option');
      if (opt.disabled) {
        li.classList.add('mp-select__option--disabled');
        li.setAttribute('aria-disabled', 'true');
      }
      li.innerHTML =
        '<span class="mp-select__option-text"></span>' +
        '<span class="mp-select__option-unit"></span>' +
        '<svg class="mp-select__option-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      // formato a sinistra, prezzo al chilo incolonnato a destra: due numeri
      // incolonnati si confrontano, due numeri in fila no
      li.children[0].textContent = opt.dataset.formato || opt.text;
      li.children[1].textContent = opt.dataset.unit || '';
      // solo queste voci hanno due colonne: le voci dei filtri restano
      // com'erano, li' i nomi sono lunghi e accorciarli serve davvero
      if (opt.dataset.unit) li.classList.add('mp-select__option--conunita');
      li.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!opt.disabled) choose(i);
      });
      li.addEventListener('mousemove', function () {
        if (!opt.disabled && activeIndex !== i) setActive(i);
      });
      list.appendChild(li);
      return li;
    });

    root.appendChild(btn);
    root.appendChild(list);

    var activeIndex = -1;

    function sync() {
      var i = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
      var valueEl = document.getElementById(id + '-value');
      // a tendina chiusa basta il formato: il prezzo e' gia' sopra
      if (valueEl && sel.options[i]) {
        valueEl.textContent = sel.options[i].dataset.formato || sel.options[i].text;
      }
      options.forEach(function (li, j) {
        li.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
    }

    function setActive(i) {
      activeIndex = Math.max(0, Math.min(i, options.length - 1));
      options.forEach(function (li, j) {
        li.classList.toggle('mp-select__option--active', j === activeIndex);
      });
      list.setAttribute('aria-activedescendant', options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function open() {
      if (openWidget && openWidget.root !== root) openWidget.close();
      document.dispatchEvent(new CustomEvent('mp:close-selects'));
      var estH = Math.min(options.length * 40 + 12, 264);
      var rect = btn.getBoundingClientRect();
      var below = window.innerHeight - rect.bottom;
      root.classList.toggle('mp-select--up', below < estH + 16 && rect.top > below);
      root.classList.add('mp-select--open');
      if (cardOspite) cardOspite.classList.add('mp-card-sopra');
      btn.setAttribute('aria-expanded', 'true');
      setActive(sel.selectedIndex < 0 ? 0 : sel.selectedIndex);
      list.focus();
      openWidget = { root: root, close: close };
    }

    function close(refocus) {
      root.classList.remove('mp-select--open');
      if (cardOspite) cardOspite.classList.remove('mp-card-sopra');
      btn.setAttribute('aria-expanded', 'false');
      if (openWidget && openWidget.root === root) openWidget = null;
      if (refocus) btn.focus();
    }

    function choose(i) {
      if (sel.selectedIndex !== i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close(true);
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.classList.contains('mp-select--open')) close(true);
      else open();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });

    list.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(activeIndex + 1); break;
        case 'ArrowUp':   e.preventDefault(); setActive(activeIndex - 1); break;
        case 'Home':      e.preventDefault(); setActive(0); break;
        case 'End':       e.preventDefault(); setActive(options.length - 1); break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (options[activeIndex] && !options[activeIndex].classList.contains('mp-select__option--disabled')) {
            choose(activeIndex);
          }
          break;
        case 'Escape':    e.preventDefault(); e.stopPropagation(); close(true); break;
        case 'Tab':       close(); break;
      }
    });

    sel._mpSelectSync = sync;
    sync();
  }

  function enhanceAll(root) {
    (root || document)
      .querySelectorAll('.mp-prod-card__variant, .mp-modal__variant')
      .forEach(enhance);
  }

  window.mpEnhanceVariantSelects = enhanceAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceAll(); });
  } else {
    enhanceAll();
  }
})();
